import axios from 'axios'

export function saveSurvey(data) {
  return axios({
    method: 'post',
    url: '/index.php?route=information/survey/save',
    headers: {'Content-Type': 'multipart/form-data'},
    data: data
  })
}
